import RouteLink from './routeLink';

export default RouteLink;
